/**
 * Chart renderer registry.
 */

import type { PlotEngine, ChartRendererProps } from '../types';
import { PlotlyRenderer } from './PlotlyRenderer';
import { RechartsRenderer } from './RechartsRenderer';

export type RendererComponent = React.ComponentType<ChartRendererProps>;

export const RENDERERS: Record<PlotEngine, RendererComponent> = {
  plotly: PlotlyRenderer,
  recharts: RechartsRenderer,
  'ag-charts': PlotlyRenderer,
  scichart: PlotlyRenderer,
};

export function getRenderer(engine: PlotEngine): RendererComponent {
  return RENDERERS[engine] ?? PlotlyRenderer;
}
